import {Pipe, PipeTransform} from '@angular/core';
import {Frequency} from 'rrule';

@Pipe({
    name: 'repeatFrequencyText',
    standalone: true
})
export class RepeatFrequencyTextPipe implements PipeTransform {

  transform(value: Frequency): string {
    console.log(value);
    switch (value) {
      case Frequency.YEARLY:
        return 'years(s)';
      case Frequency.MONTHLY:
        return 'month(s)';
      case Frequency.WEEKLY:
        return 'week(s)';
      case Frequency.DAILY:
        return 'day(s)';
      case Frequency.HOURLY:
        return 'hour(s)';
    }
    return '';
  }
}
